<div class="grid grid-cols-4 gap-4 content-center">

  <!-- <div class="min-h-[200px] grid grid-cols-4 gap-4 content-center"> -->
    <!-- <div class="min-h-[140px] h-56 grid grid-cols-4 gap-4 content-center"> -->

  <div></div>
  
    <div class="text-center">

      <img src="assets/gasdynamics.jpg" alt="">

    </div>
  
  
    <div class="text-center">

      <img src="assets/rocketprop2.jpg" alt="">

    </div>


    <div></div>

    
    
  </div>

  